<template>
  <div>
    <h1 class="text-center mt-5 text-blue">Maintenance Mode</h1>
    <h3 class="text-center mb-5 text-blue">
      The site is currently down for maintenance and we hope to restore normal
      service as soon as possible. Please accept our apologies for any
      inconvenience.
    </h3>
  </div>
</template>

<script>
export default {
  name: "Maintenance",
  metaInfo() {
    return {
      title: "FAIRsharing | Maintenance Mode",
    };
  },
};
</script>

<style scoped></style>
